import React from 'react';
import { Grid, Typography } from '@mui/material';
import { IHousingSectionProps } from 'app/models/Orders/OrderDetails';
import { useStyles } from './OrderDetailsReportStyles';
import { useTranslation } from 'react-i18next';

type HousingSectionProps = {
  housingDetails: IHousingSectionProps;
};
export const OrderDetailsReportHousingInfo = (props: HousingSectionProps) => {
  const { classes } = useStyles();
  const housingDetails = props.housingDetails;
  const { t } = useTranslation();

  return (
    <Grid container>
      <Grid xs={6} md={5}>
        <Grid container>
          <Grid xs={6} md={5} className={`${classes.labelCell}`}>
            <Typography>{t('order.orderReportDetails.housingSection.type')}:</Typography>
          </Grid>
          <Grid xs={6} md={7} className={`${classes.dataCell}`}>
            {housingDetails.housingType}
          </Grid>
        </Grid>

        <Grid container>
          <Grid xs={6} md={5} className={`${classes.alternativeLabelCell}`}>
            <Typography>{t('order.orderReportDetails.housingSection.limitations')}:</Typography>
          </Grid>
          <Grid xs={6} md={7} className={`${classes.alternativeDataCell}`}>
            {housingDetails.limitation}
          </Grid>
        </Grid>

        <Grid container>
          <Grid xs={6} md={5} className={`${classes.labelCell}`}>
            <Typography>{t('order.orderReportDetails.housingSection.descriptions')}:</Typography>
          </Grid>
          <Grid xs={6} md={7} className={`${classes.dataCell}`}>
            {housingDetails.housingDescription}
          </Grid>
        </Grid>
      </Grid>
      <Grid xs={6} md={1}></Grid>

      <Grid xs={6} md={6}>
        <Grid container className={`${classes.gridLabel}`}>
          <Grid item xs={6} md={3}>
            <Typography>{t('order.orderReportDetails.housingSection.provider')}</Typography>
          </Grid>
          <Grid item xs={6} md={4}>
            <Typography>{t('order.orderReportDetails.housingSection.description')}</Typography>
          </Grid>
          <Grid item xs={6} md={2} className={`${classes.gridrightAlign}`}>
            <Typography>{t('order.orderReportDetails.housingSection.amount')}</Typography>
          </Grid>
          <Grid item xs={6} md={3} className={`${classes.gridrightAlign}`}>
            <Typography>{t('order.orderReportDetails.housingSection.utilitycharge')}</Typography>
          </Grid>
        </Grid>
        {housingDetails.orderHousings
          .slice()
          .sort((a, b) => (b.descHousingProvider > a.descHousingProvider ? -1 : 1))
          .map((row,index) => (
            <Grid container className={`${classes.gridData}`} key={index}>
              <Grid item xs={6} md={3} >
                {row.descHousingProvider}
              </Grid>
              <Grid item xs={6} md={4} >
                {row.descHousing}
              </Grid>
              <Grid item xs={6} md={2} className={`${classes.gridrightAlign}`} >
                {row.amount}
              </Grid>
              <Grid item xs={6} md={3} className={`${classes.gridrightAlign}`} >
                {row.utilityCharge}
              </Grid>
            </Grid>
          ))}
      </Grid>
    </Grid>
  );
};
